export default "__VITE_ASSET__CZhi20Ge__"